import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { useTranslate } from 'lib/translate';
import { Form, Field } from 'react-final-form';
import { capitalize } from 'helpers/content';
import { ASSESSMENT_TYPES } from 'components/BlockAssessments/AssessmentTypes';
import SimpleSelect from 'components/Inputs/SimpleSelect';
import AssessmentDetailField from 'components/Inputs/AssessmentDetailField';
import AssessmentFeedbackField from 'components/Inputs/AssessmentFeedbackField';
import { Button, Checkbox, Expandable, Icon } from '@haldor/ui';
import { ColorLabel, ColorLabelContainer } from 'UI';
import api from 'lib/api';
import './_assessmentForm.scss';

var AssessmentForm = function AssessmentForm(props) {
  var translate = useTranslate();

  if (props.blocks == null) {
    return null;
  }

  var getInitialValues = function getInitialValues() {
    var initialValues = {};

    if (props.initialValues != null) {
      initialValues = JSON.parse(JSON.stringify(props.initialValues));
    }

    if (initialValues.assessmentFeedbacks == null) {
      initialValues.assessmentFeedbacks = [];
    }

    props.blocks.forEach(function (block) {
      if (block == null || block.resources == null) {
        return true;
      }

      block.resources.forEach(function (resource) {
        var foundFeedback = initialValues.assessmentFeedbacks.find(function (value) {
          return value.assessmentBlockPartId == resource.id && value.isPrivate == false;
        });
        var foundNote = initialValues.assessmentFeedbacks.find(function (value) {
          return value.assessmentBlockPartId == resource.id && value.isPrivate == true;
        });

        if (foundFeedback == null) {
          initialValues.assessmentFeedbacks.push({
            text: '',
            assessmentBlockPartId: resource.id,
            isPrivate: false
          });
        }

        if (foundNote == null && (props.assessmentType == ASSESSMENT_TYPES.TEACHER || props.assessmentType == null)) {
          initialValues.assessmentFeedbacks.push({
            text: '',
            assessmentBlockPartId: resource.id,
            isPrivate: true
          });
        } // Private assessmentFeedbacks should be after non private


        initialValues.assessmentFeedbacks.sort(function (a) {
          return a.isPrivate ? 1 : -1;
        });
      });
    });
    return initialValues;
  };

  var onSubmit = function onSubmit(values) {
    return new Promise(function (resolve) {
      values = JSON.parse(JSON.stringify(values));
      values.referenceId = props.referenceId;
      values.referenceType = props.referenceType;
      values.assessorType = props.assessmentType;

      if (values.assessmentFeedbacks != null) {
        values.assessmentFeedbacks = values.assessmentFeedbacks.filter(function (feedback) {
          return feedback.text != '';
        });
      }

      if (props.onSubmit != null) {
        props.onSubmit(values).then(function () {
          resolve(values);
        });
      } else {
        resolve(values);
      }
    });
  };

  var _getResourceTitle = function _getResourceTitle(resource, courses) {
    var text = null;

    if (resource.referenceType == 'assessmentGoal') {
      text = translate('Goal');
    }

    if (resource.referenceType == 'matrix') {
      text = resource.value.year != null ? "".concat(resource.value.title, " ").concat(resource.value.year) : resource.value.title;
    }

    if (resource.referenceType == 'assessmentGoal') {
      return /*#__PURE__*/React.createElement("div", {
        className: "assessmentGoal-dotContainer"
      }, /*#__PURE__*/React.createElement("span", null, text), courses.length > 0 ? courses.map(function (course) {
        var title = course.value.year != null ? "".concat(course.value.title, " ").concat(course.value.year) : course.value.title;
        return /*#__PURE__*/React.createElement(ColorLabelContainer, null, /*#__PURE__*/React.createElement(ColorLabel, {
          key: course.value.id,
          tooltip: title,
          color: course.value.colorCode
        }));
      }) : null);
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "df aic jcb"
    }, text, resource != null && resource.referenceType != 'assessmentonlyfeedback' && props.assessmentType == ASSESSMENT_TYPES.TEACHER && /*#__PURE__*/React.createElement("div", {
      className: "permissions"
    }, renderPermission('STUDENT', resource.permissions), renderPermission('GUARDIAN', resource.permissions)));
  };

  var _getResourceColor = function _getResourceColor(resource) {
    if (resource.referenceType == 'assessmentGoal') {
      return '#0f78da';
    }

    if (resource.referenceType == 'matrix') {
      return resource.value.colorCode;
    }

    return '#ccc';
  };

  var onStatusSelect = function onStatusSelect(item, value) {
    var userObj = {
      id: item.id,
      firstname: item.firstname,
      lastname: item.lastname,
      planId: item.planId,
      status: value.value
    };
    api.put("planning/student/status", userObj);
  };
  /**
   * @param {string} target
   * @param {array} permissions
   */


  var renderPermission = function renderPermission(target, permissions) {
    var active = permissions.find(function (perm) {
      return perm.target == target && perm.referenceType == 'ASSESSMENTBLOCKPART';
    }) != null;
    return /*#__PURE__*/React.createElement("div", {
      className: "permission"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: active ? "Eye" : "Eye_Off"
    }), translate(capitalize(target)));
  };

  var renderResource = function renderResource(resource, index, form) {
    var courses = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var matrix;

    if (resource.referenceType == 'matrix') {
      var _resource$value, _resource$value$detai, _resource$value$detai2;

      matrix = (_resource$value = resource.value) === null || _resource$value === void 0 ? void 0 : (_resource$value$detai = _resource$value.details) === null || _resource$value$detai === void 0 ? void 0 : (_resource$value$detai2 = _resource$value$detai.find(function (detail) {
        return detail.matrixID == resource.referenceId;
      })) === null || _resource$value$detai2 === void 0 ? void 0 : _resource$value$detai2.matrix;

      if (matrix == null || matrix._ParagraphSet == null) {
        return null;
      }
    }

    return /*#__PURE__*/React.createElement(Expandable, {
      title: _getResourceTitle(resource, courses),
      color: _getResourceColor(resource),
      key: resource.id,
      open: true,
      ignorePropsUpdate: true
    }, resource.referenceType == 'matrix' && matrix._ParagraphSet.map(function (paragraph) {
      return paragraph.rows.map(function (row) {
        var assessmentBlockPartRow = resource.assessmentBlockPartRows.find(function (selectedRow) {
          return selectedRow.referenceId == row.id;
        });

        if (assessmentBlockPartRow != null) {
          return /*#__PURE__*/React.createElement(Field, {
            name: "assessmentDetails",
            component: AssessmentDetailField,
            row: assessmentBlockPartRow,
            resource: resource,
            key: assessmentBlockPartRow.id,
            assessmentType: props.assessmentType
          });
        }
      });
    }), resource.referenceType == 'assessmentGoal' && resource.assessmentBlockPartRows.map(function (row) {
      return /*#__PURE__*/React.createElement(Field, {
        name: "assessmentDetails",
        component: AssessmentDetailField,
        row: row,
        resource: resource,
        key: row.id,
        assessmentType: props.assessmentType
      });
    }), /*#__PURE__*/React.createElement(Field, {
      name: "assessmentFeedbacks",
      component: AssessmentFeedbackField,
      resource: resource,
      assessmentType: props.assessmentType
    }));
  };

  var blocks = props.blocks;
  return /*#__PURE__*/React.createElement("div", {
    className: "form-container assessment-form"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    initialValues: getInitialValues(),
    mutators: {
      setStatusCompleted: function setStatusCompleted(args, state, utils) {
        if (props.initialValues == null || props.initialValues.status != 'ASSESSMENT_PUBLISHED') {
          utils.changeValue(state, 'status', function () {
            return 'ASSESSMENT_COMPLETED';
          });
        }
      },
      setStatusStarted: function setStatusStarted(args, state, utils) {
        utils.changeValue(state, 'status', function () {
          return 'ASSESSMENT_STARTED';
        });
      }
    },
    keepDirtyOnReinitialize: true,
    render: function render(_ref) {
      var _props$initialValues;

      var handleSubmit = _ref.handleSubmit,
          submitting = _ref.submitting,
          form = _ref.form;
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit,
        className: "form form-component"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, props.items != null && props.showStudents ? /*#__PURE__*/React.createElement(Expandable, {
        open: true,
        title: translate('Students'),
        ignorePropsUpdate: true
      }, props.items.map(function (item) {
        if (item.firstname == null) {
          return null;
        }

        var name = item.firstname;

        if (item.lastname != null) {
          name += ' ' + item.lastname;
        }

        return /*#__PURE__*/React.createElement("table", {
          style: {
            width: '100%'
          }
        }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
          key: item.id
        }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          key: item.id,
          style: {
            marginBottom: '.55rem'
          }
        }, /*#__PURE__*/React.createElement(Checkbox, {
          disabled: true,
          value: true,
          label: name
        }))), /*#__PURE__*/React.createElement("td", {
          className: "status",
          style: {
            textAlign: 'left',
            zIndex: 2
          }
        }, /*#__PURE__*/React.createElement(SimpleSelect, {
          selectedValue: props.items[0].status,
          disabled: false,
          name: "assessment-status",
          item: props.items[0],
          type: "planning",
          onChange: onStatusSelect,
          menuPosition: 'fixed',
          menuPortalTarget: document.body
        })))));
      })) : null, blocks.sort(function (a, b) {
        return a.sortorder - b.sortorder;
      }).map(function (block) {
        var goals = _toConsumableArray(block.resources).filter(function (resource) {
          return resource.referenceType == 'assessmentGoal';
        });

        var courses = _toConsumableArray(block.resources).filter(function (resource) {
          return resource.referenceType == 'matrix';
        });

        var onlyFeedbacks = _toConsumableArray(block.resources).filter(function (resource) {
          return resource.referenceType == 'assessmentonlyfeedback';
        });

        return /*#__PURE__*/React.createElement(Expandable, {
          title: block.title,
          open: true,
          key: block.id,
          ignorePropsUpdate: true
        }, goals.map(function (resource, index) {
          return renderResource(resource, index, form, courses);
        }), courses.map(function (resource, index) {
          return renderResource(resource, index, form);
        }), onlyFeedbacks.map(function (resource, index) {
          return renderResource(resource, index, form);
        }));
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick(e) {
          e.preventDefault();
          form.mutators.setStatusCompleted();
          form.submit();
        }
      }, translate('Save assessment')), props.initialValues == null || ((_props$initialValues = props.initialValues) === null || _props$initialValues === void 0 ? void 0 : _props$initialValues.status) != 'ASSESSMENT_PUBLISHED' ? /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick(e) {
          e.preventDefault();
          form.mutators.setStatusStarted();
          form.submit();
        },
        type: "secondary"
      }, translate('Save draft')) : null, props.onClose != null ? /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: props.onClose
      }, translate('Cancel'))) : null));
    }
  }));
};

AssessmentForm.defaultProps = {
  showStudents: true,
  assessmentType: "Teacher"
};
export default AssessmentForm;